import { trace } from 'owa-trace';

export function getErrorAsString(errorEnumAsString: string): string {
    const enumAsInt = parseInt(errorEnumAsString);

    // The switch is converting a OneDrive enum into human readable strings for logging. Do not change unless OneDrive changes their enum
    switch (enumAsInt) {
        case 1:
            return 'authFailure';
        case 2:
            return 'serverFailure';
        case 3:
            return 'invalidItem';
        case 4:
            return 'invalidWebAbsoluteUrl';
        case 5:
            return 'generic';
        case 6:
            return 'objectNotSupported';
        case 7:
            return 'invalidEmail';
        case 8:
            return 'linkNoLongerAvailable';
        default:
            trace.error('unexpected value for sharing dialog error enum');
            return 'newEnumValueContactODSP';
    }
}

export function getErrorCategoryAsString(errorCategoryEnumAsString: string): string {
    const enumAsInt = parseInt(errorCategoryEnumAsString);

    // The switch is converting a OneDrive enum into human readable strings for logging. Do not change unless OneDrive changes their enum
    switch (enumAsInt) {
        case 1:
            return 'getSharingInformation';
        case 2:
            return 'shareLink';
        case 3:
            return 'shareObject';
        case 4:
            return 'permissions';
        case 5:
            return 'item';
        case 6:
            return 'me';
        case 7:
            return 'drive';
        case 8:
            return 'invite';
        default:
            trace.error('unexpected value for sharing dialog error category enum');
            return 'newEnumValueContactODSP';
    }
}
